import { HttpTypes } from '@/types';
import { thirdPartyResponse } from '@/types/http';
import { AxiosInstance, AxiosRequestConfig } from 'axios';

class ThirdPartyAnalytic {
  private client: AxiosInstance;
  private routePath = '/sites';
  public host = '';

  constructor(client: AxiosInstance) {
    client.interceptors.request.use();

    this.client = client;
  }

  interceptRequest(config: AxiosRequestConfig) {
    config.headers = {
      ...config.headers,
    };

    return config;
  }

  async get(): Promise<HttpTypes.IResponse<thirdPartyResponse>> {
    this.interceptRequest({ ...this.client.request });
    const result = await this.client.get(`${this.routePath}/thirdparty-analytic`, {
      headers: {
        Origin: this.host,
        'X-Jstore-Host': this.host,
      },
    });
    return result.data;
  }
}

export default ThirdPartyAnalytic;
